"use client";

import { ArrowUp, FileText, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { whatsappHref } from "@/lib/utils";
import { trackEvent } from "@/lib/analytics";
import { AppLink as Link } from "./AppLink";

export function WhatsAppButton() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    function onScroll() {
      setShowTop(window.scrollY > 520);
    }

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <div className="floating-actions" aria-label="Accesos rápidos">
      {showTop ? (
        <button className="floating-action floating-action--quiet" type="button" aria-label="Volver al inicio" onClick={scrollToTop}>
          <ArrowUp size={20} aria-hidden="true" />
        </button>
      ) : null}
      <Link
        className="floating-action floating-action--quote"
        href="/cotizar"
        aria-label="Solicitar cotización"
        onClick={() => trackEvent("main_cta_click", { source: "floating_actions" })}
      >
        <FileText size={20} aria-hidden="true" />
        <span>Cotizar</span>
      </Link>
      <a
        className="floating-action floating-action--whatsapp"
        href={whatsappHref()}
        aria-label="Contactar por WhatsApp"
        rel="noopener noreferrer"
        onClick={() => trackEvent("whatsapp_click", { source: "floating_actions" })}
      >
        <MessageCircle size={22} aria-hidden="true" />
        <span>WhatsApp</span>
      </a>
    </div>
  );
}
